import axios from 'axios';
import { toast } from 'react-toastify';
import { contactusEndpoint } from '../apis';

// Function to send contact form data to the backend
export const sendContactForm = async (formData) => {
    const toastId = toast.loading("Sending message...");
    try {
        const response = await axios.post(contactusEndpoint.CONTACT_US_API, formData);
        if (!response.data.success) {
            throw new Error('Failed to send message');
        }
        toast.success('Message sent successfully!');
        return response.data;
    } catch (error) {
        toast.error(`Error: ${error.message}`);
        console.error('Error sending contact form data:', error);
        return null;
    } finally {
        toast.dismiss(toastId);
    }
};

export const fetchAllContacts = async () => {
    const toastId = toast.loading("Fetching contacts...");
    try {
        const response = await axios.get(contactusEndpoint.ALL_CONTACTS_API);

        // Check if the response has data and if the status is OK
        if (response.status !== 200 || !response.data || !Array.isArray(response.data)) {
            throw new Error('Failed to fetch contacts');
        }

        toast.success('Contacts fetched successfully!');
        return response.data;
    } catch (error) {
        const errMsg = error.response ? error.response.data.message || error.response.data : error.message;
        toast.error(`Error: ${errMsg}`);
        console.error('Error fetching contacts:', errMsg);
        return [];
    } finally {
        toast.dismiss(toastId);
    }
};

